/* eslint-disable import/prefer-default-export */

export const securedRoutePath = '/s'
export const showDevMenu = false
